import { BookOpen, ListChecks, Compass, Users, Sparkles, Star } from "lucide-react";
import { motion } from "framer-motion";

const ITEMS = [
  { icon: BookOpen, title: "Conteúdos por etapa", desc: "Material organizado para o momento exato em que você está." },
  { icon: ListChecks, title: "Checklists práticos", desc: "Listas objetivas para não esquecer o que importa em cada fase." },
  { icon: Compass, title: "Guias de decisão", desc: "Orientação clara para escolhas difíceis, sem achismo." },
  { icon: Users, title: "Profissionais e serviços", desc: "Especialistas e serviços selecionados para cada necessidade." },
  { icon: Sparkles, title: "Curadoria", desc: "Seleção cuidadosa de fontes, conteúdos e parceiros confiáveis." },
  { icon: Star, title: "Reviews verificados", desc: "Avaliações reais de outras famílias.", soon: true },
];

const OQueEncontra = () => {
  return (
    <section data-testid="o-que-encontra-section" className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          className="max-w-2xl mb-16"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="text-sm font-semibold tracking-widest text-maternnia-eucalipto uppercase">O que você encontra</span>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-maternnia-charcoal mt-4 font-medium">
            Recursos que apoiam as suas decisões, em um só lugar
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                data-testid={`encontra-card-${i}`}
                className="group relative bg-maternnia-porcelana rounded-3xl p-8 border border-maternnia-nevoa/60 shadow-sm hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(43,37,38,0.08)] transition-all duration-300"
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              >
                {item.soon && (
                  <span className="absolute top-6 right-6 text-[10px] font-semibold tracking-wide uppercase bg-maternnia-gold/15 text-maternnia-gold px-2.5 py-1 rounded-full">
                    Em breve
                  </span>
                )}
                <div className="h-12 w-12 rounded-2xl bg-white flex items-center justify-center mb-6 group-hover:bg-maternnia-eucalipto transition-colors duration-300">
                  <Icon size={22} className="text-maternnia-eucalipto group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="font-serif text-2xl text-maternnia-charcoal mb-2 font-medium">{item.title}</h3>
                <p className="text-sm text-maternnia-taupe leading-relaxed font-light">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OQueEncontra;
